module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.tasks.red-7b5ea9ea3abc203fb5277b11e3c54644.svg";